import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01ce2b64"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-input-name__input-wrap" }
const _hoisted_2 = {
  key: 0,
  class: "task-input-name__placeholder"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-input-name__placeholder-required" }, "*", -1))
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "task-input-name__input-row" }
const _hoisted_7 = ["onKeydown"]
const _hoisted_8 = {
  key: 1,
  class: "task-input-name__name"
}
const _hoisted_9 = {
  key: 2,
  class: "task-input-name__input-right"
}
const _hoisted_10 = {
  key: 0,
  class: "task-input-name__error-message"
}

import {
  computed,
  inject,
  isReadonly,
  nextTick,
  onMounted,
  onUnmounted,
  PropType,
  ref,
  watch,
} from "vue";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmTooltipElementPlacementEnum,
  TirPmTooltipElement,
} from "tir-components";
import {
  ClipboardDocumentIcon,
  PencilSquareIcon,
  CheckIcon,
  CrossCompactIcon,
} from "tir-style-system/icons/outline";
import { TaskInputNameModeEnum } from "./enums";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-input-name',
  props: {
  /**Возможность редактировать */
  editing: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
  /**Значение */
  modelValue: {
    type: String,
    default: "",
  },
  /**Режим работы инпута */
  mode: {
    type: String as PropType<TaskInputNameModeEnum>,
    default: TaskInputNameModeEnum.Create,
  },
  /**Сообщение об ошибке */
  errorMessage: {
    type: String,
  },
  /**Удалить паддинг по x */
  noXPadding: {
    type: Boolean,
    default: false,
  },
  /**Автофокус */
  autoFocus: {
    type: Boolean,
    default: false,
  },
  /**Блокировка */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Режим импорта */
  isImportMode: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:modelValue", "update:mode", "copyName"],
  setup(__props, { emit }) {

const props = __props;





/**Ссылка на инпут */
const $input = ref<HTMLInputElement>();

const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  () => {
    inputValue.value = props.modelValue;
  },
);

const onTriggerToTopScroll = () => {
  if (isFixedNameConten.value) {
    document.querySelector(parentScrollContainer).scrollTo({ top: 0, behavior: "smooth" });
  }
};

const onClickEdit = async () => {
  if (!props.isDisabled) {
    emit("update:mode", TaskInputNameModeEnum.Edit);
    await nextTick();
    $input.value?.focus();
  }
};

const onClickSave = async () => {
  emit("update:modelValue", inputValue.value);
  emit("update:mode", TaskInputNameModeEnum.View);
};

const onClickCancelSave = async () => {
  inputValue.value = props.modelValue;
  emit("update:mode", TaskInputNameModeEnum.View);
};

const value = computed({
  get() {
    return inputValue.value;
  },
  set(value) {
    inputValue.value = value;
    if (props.mode === TaskInputNameModeEnum.Create) emit("update:modelValue", value);
  },
});

const onBlur = () => {
  if (props.mode === TaskInputNameModeEnum.Edit) {
    onClickCancelSave();
  }
};

const parentScrollContainer: string = inject("parent-scroll-container");
const isFixedNameConten = ref<boolean>(false);

const checkScrollParentPosition = (e: Event) => {
  let parentContainerScrollTop: HTMLElement = e.target;
  isFixedNameConten.value = parentContainerScrollTop.scrollTop > 290;
};

onMounted(() => {
  if (props.autoFocus) {
    $input.value?.focus();
  }
  document
    .querySelector(parentScrollContainer)
    ?.addEventListener("scroll", checkScrollParentPosition);
});
onUnmounted(() => {
  document
    .querySelector(parentScrollContainer)
    ?.removeEventListener("scroll", checkScrollParentPosition);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['task-input-name', { 'no-x-padding': __props.noXPadding }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!inputValue.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (!__props.isImportMode)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createTextVNode(" Введите название тикета"),
                  _hoisted_4
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_5, " Название тикета "))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (__props.mode !== _unref(TaskInputNameModeEnum).View && !__props.isDisabled)
          ? _withDirectives((_openBlock(), _createElementBlock("input", {
              key: 0,
              ref_key: "$input",
              ref: $input,
              class: "task-input-name__input",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
              onBlur: onBlur,
              onKeydown: _withKeys(onClickSave, ["enter"])
            }, null, 40, _hoisted_7)), [
              [_vModelText, value.value]
            ])
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", {
                class: _normalizeClass(["task-input-name__name-content", { 'task-input-name__name-content--fixed': isFixedNameConten.value }]),
                onClick: onTriggerToTopScroll,
                onDblclick: onClickEdit
              }, _toDisplayString(value.value), 35),
              _createVNode(_unref(TirPmTooltipElement), {
                position: _unref(TirPmTooltipElementPlacementEnum).Right
              }, {
                content: _withCtx(() => [
                  _createTextVNode("Скопировать в буфер")
                ]),
                default: _withCtx(() => [
                  (__props.mode === _unref(TaskInputNameModeEnum).View)
                    ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                        key: 0,
                        class: "task-input-name__edit-button",
                        variant: _unref(TirPmButtonVariantEnum).LinkState,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('copyName')))
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(ClipboardDocumentIcon))
                        ]),
                        _: 1
                      }, 8, ["variant", "size"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["position"])
            ])),
        (__props.mode !== _unref(TaskInputNameModeEnum).Create && __props.editing && !__props.isDisabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (__props.mode === _unref(TaskInputNameModeEnum).View)
                ? (_openBlock(), _createBlock(_unref(TirPmTooltipElement), {
                    key: 0,
                    position: _unref(TirPmTooltipElementPlacementEnum).Left
                  }, {
                    content: _withCtx(() => [
                      _createTextVNode("Редактировать")
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_unref(TirPmButton), {
                        variant: _unref(TirPmButtonVariantEnum).LinkState,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        onClick: onClickEdit
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(PencilSquareIcon))
                        ]),
                        _: 1
                      }, 8, ["variant", "size"])
                    ]),
                    _: 1
                  }, 8, ["position"]))
                : (__props.modelValue !== inputValue.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_unref(TirPmButton), {
                        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        onClick: _withModifiers(onClickSave, ["prevent"]),
                        onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(CheckIcon))
                        ]),
                        _: 1
                      }, 8, ["variant", "size", "onClick"]),
                      _createVNode(_unref(TirPmButton), {
                        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        onClick: onClickCancelSave,
                        onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(CrossCompactIcon))
                        ]),
                        _: 1
                      }, 8, ["variant", "size"])
                    ], 64))
                  : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.errorMessage), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})